import React, { useState } from "react";
import EditorNew from "./../Editor/EditorNew";
import ChatEditor from "../Editor/ChatEditor";

const PopOver = (props) => {
  const [isShowPopup, setShowPopup] = useState(false);
  const [formdata, setFormdata] = useState("");
  const [noteContent, setNoteContent] = useState("");
  const {
    chatIndex,
    transcriptId,
    userUUID,
    applyColor,
    userList,
    getChatNotes,
    setDisplayIcon,
    updateChat,
    chatContent,
    removeColor,
  } = props.obj;
  const [editId, setEditId] = useState(1);
  const [noteError, setNoteError] = useState(false);

  const formsubmithandler = () => {
    if (noteContent.chat_note && noteContent.chat_note.text.length == "") {
      setNoteError(true);
      return false;
    }
    setShowPopup(false);
    updateChat();
    const resp = fetch(`${process.env.REACT_APP_tattle_api}/note/create`, {
      method: "POST",
      body: JSON.stringify({
        attribute_set_key: "live-chat",
        app_token: process.env.REACT_APP_tattle_token,
        customer_tattle_uuid: Number(transcriptId),
        user_uuid: userUUID,
        note_content: noteContent.chat_note.html_content,
        note_content_json:
          noteContent.chat_note.draft_js_content &&
          noteContent.chat_note.draft_js_content,
        mention: noteContent.mentioned_data && noteContent.mentioned_data,
        highlight_text: chatContent,
        note_type: "live-chat",
        attribute_set_type: 1,
      }),
    });
    resp
      .then((item) => {
        return item.json();
      })
      .then((data) => {
        //
        setNoteContent("");
        getChatNotes(transcriptId);
        setEditId(2);
      });
  };
  const textareaHandler = (evt) => {
    setNoteContent(evt);
  };

  const popupHandler = () => {
    setShowPopup(!isShowPopup);
    applyColor();
  };

  return (
    <React.Fragment>
      <div className="comment-icon">
        <i
          class="fa fa-light fa-comments"
          onClick={popupHandler}
          title="comment"
        ></i>
      </div>
      <div className={`popup-over ${isShowPopup ? "active" : "inactive"}`}>
        <div class="profile-img-box">
          <img src={userList[userUUID] && userList[userUUID].profile_pic} />
          <span> {userList[userUUID] && userList[userUUID].name}</span>
        </div>
        {noteError ? (
          <label className="error-msg">Please fill the field*</label>
        ) : (
          ""
        )}
        <ChatEditor
          getEditorData={textareaHandler}
          show_toolbar={false}
          field_name="chat_note"
          edit_id={editId}
          users={userList || {}}
        />
        <div class="actions-button">
          <button className="btn btn-primary" onClick={formsubmithandler}>
            Submit
          </button>
          <button
            className="btn btn-default"
            onClick={() => {
              setShowPopup(false);
              setDisplayIcon(false);
              removeColor();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
export default PopOver;



// WEBPACK FOOTER //
// ./src/components/chat/PopOver.js